<template>
  <form v-on:submit="submit" id="enrollPotentialeeForm" novalidate>
    <div class="form-row">
      <div class="col-md-4 mb-3">
        <label for="firstName">First name</label>
        <input
          v-model="potentialeeData.firstName"
          type="text"
          class="form-control"
          id="firstName"
          placeholder="First name"
          required
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-2 mb-2">
        <label for="middleName">Middle name</label>
        <input
          v-model="potentialeeData.middleName"
          type="text"
          class="form-control"
          id="middleName"
          placeholder="Middle name"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-4 mb-3">
        <label for="lastName">Last name</label>
        <input
          v-model="potentialeeData.lastName"
          type="text"
          class="form-control"
          id="lastName"
          placeholder="Last name"
          required
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-2 mb-2">
        <label for="nameSuffix">Name suffix</label>
        <input
          v-model="potentialeeData.nameSuffix"
          type="text"
          class="form-control"
          id="nameSuffix"
          placeholder="Name suffix"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
    </div>

    <div class="form-group">
      <label>Badges</label>
      <v-select
        :options="badges"
        :multiple="true"
        :close-on-select="false"
        :reduce="badge => badge.id"
        v-model="potentialeeData.badgeIds"
        placeholder="Click to select badges"
        label="name"
      />
    </div>

    <div class="form-group">
      <label>Location</label>
      <v-select
        :options="locations"
        v-model="potentialeeData.location"
        placeholder="Click to Select Location"
        label="name"
        :style="typeSelectorStyle"
      />
    </div>

    <div class="form-group">
      <div>
        <label for="age">Age</label>
        <input
          v-model="potentialeeData.age"
          type="number"
          class="form-control"
          id="age"
          placeholder="Age"
          required
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
    </div>
    <div class="form-group">
      <label for="locationFrom">Location from</label>
      <input
        v-model="potentialeeData.locationFrom"
        type="text"
        class="form-control"
        id="locationFrom"
        placeholder="Location from"
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    
    <!--<div class="custom-control custom-checkbox form-group">
      <input
        v-model="potentialeeData.stayingInVegas"
        class="custom-control-input"
        id="stayingInVegas"
        type="checkbox"
      />
      <label class="custom-control-label" for="stayingInVegas">Staying in Vegas</label>
      <div class="valid-feedback">Looks good!</div>
    </div>-->

    <div class="form-group">
      <label for="educationLevel">Education level</label>
      <input
        v-model="potentialeeData.educationLevel"
        type="text"
        class="form-control"
        id="educationLevel"
        placeholder="Education Level"
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    <div class="form-group">
      <label for="otherLanguages">Other languages</label>
      <input
        v-model="potentialeeData.otherLanguages"
        type="text"
        class="form-control"
        id="otherLanguages"
        placeholder="Other languages"
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    
    <!--<div class="form-group">
      <label for="skillsTraining">Skills training</label>
      <input
        v-model="potentialeeData.skillsTraining"
        type="text"
        class="form-control"
        id="skillsTraining"
        placeholder="Skills training"
        required
      />
      <div class="valid-feedback">Looks good!</div>
    </div>-->

    <!--<div class="form-group">
      <input
        v-model="potentialeeData.jobHistory"
        type="text"
        class="form-control"
        id="jobHistory"
        placeholder="Job history"
        required
      />
      <div class="valid-feedback">Looks good!</div>
    </div>-->
    <h5 for="skills">Skills</h5>

    <div class="form-row" v-for="skill in potentialeeData.skills" :key="skill.id">
      <div class="col-md-12 mb-3">
        <label for="skill">Skill</label>
        <input
          v-model="skill.about"
          type="text"
          class="form-control"
          id="skill"
          placeholder="Skill"
          required
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
    </div>
    <div class = "form-row">
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-plus-circle" @click="potentialeeData.skills.push({})"></i>
      </div>
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-minus-circle" @click="potentialeeData.skills.pop()"></i>
      </div>
    </div>
    <br>

    <h5 for="jobHistory">Job History</h5>

    <div class="form-row" v-for="job of potentialeeData.pastJobs" :key="job.id">
      <div class="col-md-4 mb-3">
        <label for="jobEmployer">Employer</label>
        <input
          v-model="job.employer"
          type="text"
          class="form-control"
          id="jobEmployer"
          placeholder="Employer"
          required
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-4 mb-3">
        <label for="jobTitle">Title</label>
        <input
          v-model="job.title"
          type="text"
          class="form-control"
          id="jobTitle"
          placeholder="Job Title"
          required
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-2 mb-2">
        <label for="jobStartDate">Start</label>
        <input
          v-model="job.startDate"
          type="text"
          class="form-control"
          id="jobStartDate"
          placeholder="Start Date"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
      <div class="col-md-2 mb-2">
        <label for="jobEndDate">End</label>
        <input
          v-model="job.endDate"
          type="text"
          class="form-control"
          id="jobEndDate"
          placeholder="End Date"
        />
        <div class="valid-feedback">Looks good!</div>
      </div>
    </div>
    <div class = "form-row">
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-plus-circle" @click="potentialeeData.pastJobs.push({})"></i>
      </div>
      <div class="col-md-1 mb-0.1">
        <i class="fa fa-minus-circle" @click="potentialeeData.pastJobs.pop()"></i>
      </div>
    </div>
    <br>
    <div class="form-group">
      <label for="personalPhone">Personal phone</label>
      <input
        v-model="potentialeeData.personalPhone"
        type="text"
        class="form-control"
        id="personalPhone"
        maxlength="12"
        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
        placeholder="Personal Phone (Format: 123-456-7890)"
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    <div class="form-group">
      <label for="personalEmail">Personal email</label>
      <input
        v-model="potentialeeData.personalEmail"
        type="email"
        class="form-control"
        id="personalEmail"
        placeholder="Personal Email"
        
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    <div class="form-group">
      <label>Background</label>
      <v-select
        :options=backgroundList
        :multiple="true"
        v-model="potentialeeData.background"
        placeholder="Click to select background"
        label="type"
      />
    </div>

    <div class="form-group">
      <label for="about">About</label>
      <input
        v-model="potentialeeData.about"
        type="text"
        class="form-control"
        id="about"
        placeholder="About"
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    <div class="form-group">
      <label for="interests">Interests</label>
      <input
        v-model="potentialeeData.interests"
        type="text"
        class="form-control"
        id="interests"
        placeholder="Interests"
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    <div class="form-group">
      <label for="about">Other Accomplishments</label>
      <input
        v-model="potentialeeData.otherAccomplishments"
        type="text"
        class="form-control"
        id="otherAccomplishments"
        placeholder="Other Accomplishments"
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    <div class="form-group">
      <label for="readyToWorkDate">Ready to work date</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="ni ni-calendar-grid-58"></i>
          </span>
        </div>
        <flat-pickr
          v-model="potentialeeData.readyToWorkDate"
          class="form-control flatpickr flatpickr-input"
          id="readyToWorkDate"
          required
          placeholder="Select date"
          name="date"
          :style="typeSelectorStyle2"
        />
      </div>
    </div>

    <div class="form-group mb-2" v-if="$store.state.usermain.curOrg.enablePhotoEditsField">
      <label for="profilePhotoEdits">Select profile photo and edits</label>
      <input
        v-model="potentialeeData.profilePhotoEdits"
        type="text"
        class="form-control"
        id="profilePhotoEdits"
        placeholder="Profile Photo Edits"
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    <div class="form-group">
      <label
        v-if="!$store.state.usermain.curOrg.enablePhotoEditsField"
        for="files"
      >Select profile photo</label>
      <div class="custom-file">
        <input
          type="file"
          class="custom-file-input"
          id="files"
          name="file"
          ref="uploadInput"
          :multiple="false"
          required
          @change="detectFiles($event)"
        />
        <label v-if="potentialeeProfilePhoto" class="custom-file-label" for="files">
          <b>Selected {{potentialeeProfilePhoto.name}}</b>
        </label>
        <label v-else class="custom-file-label" for="files">Select an image less then 10MB</label>
        <div class="invalid-feedback">You must select a file to upload before submitting.</div>
      </div>
    </div>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value id="invalidCheck" required />
        <label class="form-check-label" for="invalidCheck">Agree to terms and conditions</label>
        <div class="invalid-feedback">You must agree before submitting.</div>
      </div>
    </div>
    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value id="publicProfile" v-model="potentialeeData.public"/>
        <label class="form-check-label" for="invalidCheck">Public Profile</label>
      </div>
    </div>
    <button class="btn btn-primary" type="submit">Submit form</button>
    <div class="form-group" v-show="loaderIcon">
      <br>
      <div class="lds-dual-ring"></div><br>
      <span>Loading...</span>
    </div>
  </form>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import firebase from "@/config/firebase.js";
import { firestorage } from "@/config/firebase.js";
require("bootstrap/dist/js/bootstrap.js");

import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "enrollpotentialeeform",
  components: {
    "flat-pickr": FlatPickr
  },
  data() {
    return {
      progressUpload: 0,
      loaderIcon: false,
      badges: [],
      backgroundList: ['Drug Abuse / Use of Illegal Drugs', 
      'Property Crimes',
      'Assault',
      'Violent Crimes',
      'Violation of Liquor Laws',
      'Public Drunkenness',
      'Aggravated Assault',
      'Burglary',
      'Fraud',
      'Carrying Unlicensed Deadly Weapons',
      'Violation of Curfew and Anti-Loitering Laws',
      'Domestic Violence and Child Abuse',
      'Stolen Property Violations',
      'Motor Vehicle Theft',
      'Forgery and Counterfeiting',
      'Grand Theft Auto',
      'Domestic Violence',
      'Child Abuse',
      'Sexual Assault/Sex Crime',
      'Weapons Violation',
      'Vandalism',
      'Public Intoxication',
      'Violent Crime (Manslaughter, Homicide)',
      'Robbery',
      'Arson',
      'Larceny',
      'Driving under the Influence (DUI)'],
      locations: [],
      typeSelectorStyle: null,
      typeSelectorStyle2: null,
      potentialeeProfilePhoto: null,
      potentialeeData: {
        firstName: "",
        middleName: "",
        lastName: "",
        location: "",
        about: "",
        interests: "",
        otherAccomplishments: "",
        nameSuffix: "",
        age: null,
        locationFrom: "",
        profilePhotoEdits: "",
        //stayingInVegas: false,
        educationLevel: "",
        background: [],
        otherLanguages: "",
        skillsTraining: "",
        skills:[],
        jobHistory: "",
        personalPhone: "",
        personalEmail: "",
        readyToWorkDate: "",
        pastJobs:[],
        public: true,
        badgeIds: [],
        enrollDate: null
      }
    };
  },
  mounted() {
    this.getBadges();
    this.getLocations();
    //this.potentialeeData.pastJobs.push('');
    //this.potentialeeData.skills.push('');
  },
  computed: {
    potentialeeDataLocation: function() {
      return this.potentialeeData.location;
    }
  },
  watch: {
    potentialeeDataLocation(newLocation, _) {
      if (this.typeSelectorStyle != null && this.potentialeeData.location != "") {
        this.typeSelectorStyle = {
          border: "1px solid #1CCF87",
          "border-radius": "0.375rem"
        };
      }
      if (this.typeSelectorStyle2 != null && this.potentialeeData.readyToWorkDate != "") {
        this.typeSelectorStyle2 = {
          border: "1px solid #1CCF87",
          "border-radius": "0.375rem"
        };
      }
    }
  },
  methods: {
    getBadges() {
      const self = this;

      firebase
        .firestore()
        .collection("badges/")
        .get()
        .then(function(querySnapshot) {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;

            return docData;
          });

          self.badges = Object.values(documents);
        });
    },
    refreshCurrentPotentialeesData() {
      this.$parent.$parent.currentPageRefresh();
    },
    getLocations() {
      const self = this;

      firebase
        .firestore()
        .collection("locations/")
        .get()
        .then(function(querySnapshot) {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;

            return docData;
          });

          self.locations = Object.values(documents);
        });
    },
    submit: function(event) {
      const form = document.getElementById("enrollPotentialeeForm");

      event.preventDefault();
      event.stopPropagation();

      form.classList.add("was-validated");

      if (form.checkValidity() && (this.potentialeeData.location != "" || pData.rtwDate != undefined || pData.rtwDate != "")) {
        this.typeSelectorStyle = {
          border: "1px solid #FE6237",
          "border-radius": "0.375rem"
        };
        this.typeSelectorStyle2 = {
          border: "1px solid #FE6237",
          "border-radius": "0.375rem"
        };

        const pData = this.potentialeeData;
        const curOrgId = this.$store.state.usermain.curOrg.id;

        let rtwDate = new Date(pData.readyToWorkDate);
        rtwDate.setTime(rtwDate.getTime() + (rtwDate.getTimezoneOffset()*60*1000));

        const finalPotentialeeData = {
          firstName: pData.firstName,
          middleName: pData.middleName,
          lastName: pData.lastName,
          about: pData.about,
          location: pData.location,
          interests: pData.interests,
          otherAccomplishments: pData.otherAccomplishments,
          nameSuffix: pData.nameSuffix,
          age: parseInt(pData.age),
          background: pData.background,
          locationFrom: pData.locationFrom,
          profilePhotoEdits: pData.profilePhotoEdits,
          //stayingInVegas: pData.stayingInVegas,
          educationLevel: pData.educationLevel,
          otherLanguages: pData.otherLanguages,
          skillsTraining: pData.skillsTraining,
          jobHistory: pData.jobHistory,
          skills: pData.skills,
          personalPhone:
            parseInt(pData.personalPhone.replace("-", "").replace("-", "")) ||
            "",
          personalEmail: pData.personalEmail,
          readyToWorkDate: rtwDate,
          addedByOrg: curOrgId,
          pastJobs: pData.pastJobs,
          public: pData.public,
          badgeIds: pData.badgeIds,
          enrollDate: new Date()
        };

        firebase
          .firestore()
          .collection(`organizations/${curOrgId}/potentialees/`)
          .add(finalPotentialeeData)
          .then(ref => {
            if (ref.id) {
              this.uploadProfilePhoto(ref.id);
              this.loaderIcon = true;
              $('#enrollPotentialee').animate({ scrollTop: $('#enrollPotentialee .modal-dialog').height() }, 500);
              setTimeout(() => {
                  $("#enrollPotentialee").modal("hide");
                  this.refreshCurrentPotentialeesData();
              }, 5000);   
              
            }
          })
          .catch(function(error) {
            console.error(error);
          });
      }

      if (this.potentialeeData.location === "") {
        this.typeSelectorStyle = {
          border: "1px solid #FE6237",
          "border-radius": "0.375rem"
        };
      } else {
        this.typeSelectorStyle = {
          border: "1px solid #1CCF87",
          "border-radius": "0.375rem"
        };
      }
      if (this.potentialeeData.readyToWorkDate === "") {
        this.typeSelectorStyle2 = {
          border: "1px solid #FE6237",
          "border-radius": "0.375rem"
        };
      } else {
        this.typeSelectorStyle2 = {
          border: "1px solid #1CCF87",
          "border-radius": "0.375rem"
        };
      }
    },
    detectFiles(event) {
      const fileList = event.target.files || event.dataTransfer.files;
      const file = fileList[0];

      if (file.size < 10 * 1024 * 1024 && file.type.substring(0, 6) === "image/") {
        //console.log("GOOD FILE " + file);
        this.potentialeeProfilePhoto = file;
      } else {
        //console.log("BAD FILE " + file);
      }
    },
    uploadProfilePhoto(potentialeeId) {
      const file = this.potentialeeProfilePhoto;

      firestorage
        .ref(`potentialees/${potentialeeId}/images/profile.png`)
        .put(file)
        .catch(function(error) {
          console.error(error);
        });
    }
  }
};
</script>

<style scoped>
.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #50c7d9;
  border-color: #50c7d9 transparent #50c7d9 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
